
import { AxiosResponse } from 'axios';
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import axios from "../../../lib/axios";
import { QData } from "../../../types/basic-type-list";
import { IDeleteDataResponseAndPayload, TResponse, TResponseWithQData } from "../../../types/common";
import { IServicePayloadAndResponse } from '../../../types/api/service';


export async function saveService(data: IServicePayloadAndResponse): Promise<AxiosResponse<TResponse<IServicePayloadAndResponse>>> {
    return axios.post<TResponse<IServicePayloadAndResponse>>(API_ENDPOINTS.SERVICE_SAVE, data)
}

export async function listServices(qData: QData): Promise<AxiosResponse<TResponseWithQData<IServicePayloadAndResponse[]>>> {
    return axios.get(API_ENDPOINTS.SERVICE_LIST, {
        params: qData
    })
}

export async function deleteService(data: IDeleteDataResponseAndPayload): Promise<AxiosResponse<TResponse<IDeleteDataResponseAndPayload>>> {
    return axios.post<TResponse<IDeleteDataResponseAndPayload>>(API_ENDPOINTS.SERVICE_DELETE, data)
}


export async function serviceDetails(id:string): Promise<AxiosResponse<TResponse<IServicePayloadAndResponse>>> {
    return axios.get(`${API_ENDPOINTS.SERVICE_DETAILS}/${id}`)
}

